/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * FIELD (Vorgabe) — der Wert eines Feldes des geoeffneten Datensatzes.
 * So war es immer, und ohne Angabe bleibt es dabei.
 * 
 * CURRENT_PAGE — der NAME der gerade offenen Seite. Gebraucht fuer
 * Bausteine im Kopf- und Fussbereich, die je Seite anders aussehen
 * muessen: Auf der Startseite ist der Knopf weg, im Setup heisst er
 * „‹ Start", im Spiel „Neu starten". Ein Feld des Datensatzes kann das
 * nicht beantworten — die Seite ist keine Eigenschaft der Runde.
 * @export
 */
export const DatabaseVisibilitySource = {
    Field: 'FIELD',
    CurrentPage: 'CURRENT_PAGE',
    ErsteSeite: 'ERSTE_SEITE'
} as const;
export type DatabaseVisibilitySource = typeof DatabaseVisibilitySource[keyof typeof DatabaseVisibilitySource];


export function DatabaseVisibilitySourceFromJSON(json: any): DatabaseVisibilitySource {
    return DatabaseVisibilitySourceFromJSONTyped(json, false);
}

export function DatabaseVisibilitySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseVisibilitySource {
    return json as DatabaseVisibilitySource;
}

export function DatabaseVisibilitySourceToJSON(value?: DatabaseVisibilitySource | null): any {
    return value as any;
}

